//En este container se muestra un resumen de los datos del cierre diario y la opciópn de cerrar el día.
//En este componente no se permite cambiar el centro ni el dia de cierre.
//Se genera una estructura con los dados ya dispoonibles del cierre diario de:
//      - Cajas.
//          - Conceptos (ingresos o cobros).
//              - Productos.
// Se muestra el total de los productos de cada zona y concepto para detectar descuadres.
// Se obtiene y se muestra un resumen con los descuadres mediante la acción getResumenCierreDiario.
// Se obtiene y se muestra el número de partidas mediante la acción getPartidasPorTipo.
// El boton de cerrar:
//  - comprueba que el descuadre no sea mayor de 5€, y en el caso de que así lo sea muestra un diálogo modal para permitir introioducir las observaciones por descuadre.
//  - acción cerrarDiaCierreDiario para cerrar el día
//  - llama al servidor de reports para obtener el report del resumen diario.
// Si el día ya estaba cerrado y el usuario tiiene los permisos adecuados el botón de cerrar muestra el texto 'Modificar cierre'.
// El botón de modificar cierre desbloquea el día (unlockCierreDiario) y vuelve a mostrar el primer step (CierreDiarioDatos) de AccCierreDiario.



import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';

//material ui components:
import CircularProgress from '@material-ui/core/CircularProgress';
import { withStyles } from '@material-ui/core/styles';
import { Paper, Typography } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import { Tooltip, Fade } from '@material-ui/core';

import { getResumenCierreDiario, cerrarDiaCierreDiario, unlockCierreDiario } from '../../actions/cierre_diario_actions';
import { openDialog, hideDialog } from '../../actions/index';


import FloatNumberFormatText from '../../components/float_number_text_formatter';
import IntNumberFormatText from '../../components/int_number_text_formatter';
import { getData, createReport, postData } from '../../dataLib';

const styles = theme => ({
    root: {
        ...theme.mixins.gutters(),
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
        margin: theme.spacing(1),
        flexGrow: 1,
        fontSize: 13,
        fontWeight: '600',
    },
    paperCaja: {
        backgroundColor: theme.palette.primary.light,
        boxShadow: 'none',
        borderBottom: '3px solid #b8b8b8',
        borderRight: '3px solid #b8b8b8',
        borderRadius: '0px',
        margin: '25px 0',
        padding: 10,
    },
    paperConcepto: {
        padding: 0,
        margin: 0,
        borderBottom: '3px solid #b8b8b8',
        borderRight: '3px solid #b8b8b8',
        borderRadius: 0,
    },
    cajaSection: {
        display: 'flex',
        justifyContent: 'space-between',
        margin: 0,
        padding: '0 0 10px',
        borderRadius: 0,
        background: theme.palette.primary.light,
    },
    cajaSectionLeft: {
        display: 'flex',
        padding: '0 10px 0 8px',
        width: '50%',
        justifyContent: 'space-between',
    },
    cajaSectionRight: {
        display: 'flex',
        justifyContent: 'flex-end',
        width: '50%',
    },
    cajaSectionItem: {
        display: 'flex',
        justifyContent: 'space-evenly',
        width: '35%',
    },
    cajaSectionFontDescr: {
        fontSize: 13,
        fontWeight: '700',
        textTransform: 'uppercase',
    },
    cajaSectionFont: {
        fontSize: 13,
        fontWeight: '700',
    },
    paperZona: {
        padding: 0,
        margin: 0,
        borderRadius: 0,
        marginBottom: 28,
    },
    conceptTitleContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        padding: '4px 2px 4px 12px',
        backgroundColor: theme.palette.primary.main,
    },
    conceptTitleContainerSecondary: {
        display: 'flex',
        justifyContent: 'space-between',
        padding: '4px 2px 4px 12px',
        backgroundColor: theme.palette.secondary.main,
    },
    conceptTitleContainerblack: {
        display: 'flex',
        justifyContent: 'space-between',
        padding: '4px 2px 4px 12px',
        backgroundColor: 'black',
    },
    topGrid: {
        display: 'flex',
        justifyContent: 'space-between',
        backgroundColor: '#e6e6e6',
        padding: '3px 0',
        borderBottom: '3px solid #b8b8b8',
        fontSize: 13,
        fontWeight: '700',
    },
    gridRow: {
        display: 'flex',
        justifyContent: 'space-between',
        fontSize: 13,
        padding: '4px 10px',
        borderBottom: '1px solid #8bc34a',
        "&:last-child": {
            borderBottom: 'none'
        },
    },
    gridCellsHeaderleft: {
        width: '33%',
        padding: '3px 3px 3px 20px',
    },
    gridCellsHeaderCenter: {
        width: '33%',
        padding: '3px 10px 3px 3px',
        textAlign: 'right',
    },
    gridCellsHeaderRight: {
        width: '33%',
        padding: '3px 20px 3px 3px',
        textAlign: 'right',
    },
    gridCells: {
        width: '33%',
        padding: '0 10px',
        fontWeight: '500',
    },
    rtl: {
        textAlign: 'right',
    },
    conceptTitle: {
        fontSize: 13,
        fontWeight: '500',
        color: 'white',
    },
    conceptSectionItem: {
        display: 'flex',
        justifyContent: 'space-around',
        width: '34%',
    },
    spinnerContainer: {
        width: '95%',
        height: 300,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    spinner: {
        width: '50px !important',
        height: '50px !important',
    },
    buttonsBottom: {
        marginRight: 15,
        padding: '10px 4%',
        marginBottom: 60,
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
    },
    paperResumenTable: {
        backgroundColor: '#efefef',
        padding: theme.spacing(1),
        elevation: 3
    },
    typoError: {
        fontSize: 13,
        color: 'red'
    },
    typoDefault: {
        fontSize: 13,
        color: 'black'
    },
    typoOK: {
        fontSize: 13,
        color: 'green'
    },
    tooltip: {
        fontSize: 14,
        color: "white",
        backgroundColor: '#3a3434',
        fontWeight: 200,
    },
});

class CierreDiarioResumen extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            partidas: 0.0,
            descuadreBarBolera: 0.0,
            descuadreBar: 0.0,
            descuadreBolera: 0.0,
            descuadreArcade: 0.0,
            cajaBar: -1,
            cajaBolera: -1,
            cajaArcade: -1,
            arqueoGeneralId: -1,
            showSpinner: false,
            datosCierre: [],
        };
    };

    componentDidMount() {
        this.getPartidasPorTipo();
        this.props.getResumenCierreDiario(this.props.centroDiaSelected.centro.id, this.props.centroDiaSelected.dia);
        this.parseCierreDiarioData();
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.centroDiaSelected.centro.id !== this.props.centroDiaSelected.centro.id ||
            prevProps.centroDiaSelected.dia !== this.props.centroDiaSelected.dia) {
            this.setState({ showSpinner: true })
            this.props.getDatosCierreDiario(this.props.centroDiaSelected.centro.id, this.props.centroDiaSelected.dia);
        };
        if (prevProps.isLoading !== this.props.isLoading) this.setState({ showSpinner: this.props.isLoading });
        if (prevProps.isLoading !== this.props.isLoading) this.setState({ showSpinner: this.props.isLoading });
    };

    parseCierreDiarioData = () => {
        //create object from this.props.datosCierreDiario

        let descuadreBarBolera = 0.0;
        let descuadreBar = 0.0;
        let descuadreBolera = 0.0;
        let descuadreArcade = 0.0;
        let cajaBolera = -1;
        let cajaBar = -1;
        let cajaArcade = -1;

        let ventaPacksBar = 0.0;
        const packsBar = this.props.datosCierreDiario.find(p => p.iTipoZona === 1 && p.iKind === -8);
        if (packsBar !== undefined) {
            ventaPacksBar = packsBar.importe;
        };

        /*  let importeGastosGeneral = 0.0;
         const gastosGeneral = this.props.datosCierreDiario.find(p => p.iTipoZona === 9 && p.iKind === 4);
         if (gastosGeneral !== undefined) {
             importeGastosGeneral = gastosGeneral.importe;
         } */

        var datosCierre = [];

        //create a control for each of the items from this.props.datosCierreDiario
        this.props.datosCierreDiario.forEach(item => {

            let item_cajaId = Math.abs(item.cajaId);

            //if (item.iTipoZona !== 9) {

            if (typeof datosCierre[item_cajaId] === 'undefined') { //no existe la caja
                datosCierre[item_cajaId] = { cajaId: item.cajaId, descr: item.caja, iTipoZona: item.iTipoZona, conceptos: [], descuadre: 0.0, partidas: false };
            }

            const caja = datosCierre[item_cajaId];


            if (typeof caja.conceptos[item.isMovCaja] === 'undefined') { //no existe el concepto
                caja.conceptos[item.isMovCaja] = { concepto: item.concepto, isMovCaja: item.isMovCaja, productos: [], total: 0.0 };
            }

            const concepto = caja.conceptos[item.isMovCaja];

            if (item.iKind === -5) caja.partidas = true;

            concepto.productos.push(item);
            //}

        });


        //sort items
        datosCierre.forEach(caja => {
            caja.conceptos.forEach(concepto => {
                concepto.productos.sort(this.compareProductos);
            });
        });
        datosCierre.sort(this.compareDescr);

        datosCierre.forEach(caja => {

            const conceptoIngresos = caja.conceptos[0];
            const conceptoPagos = caja.conceptos[1];

            if (conceptoIngresos !== undefined) {
                let total = 0.0;
                conceptoIngresos.productos.forEach(p => {
                    if (p.iTipoZona === 0 && p.iKind === -5) p.ingresoCorregido = parseFloat(p.importe) - parseFloat(ventaPacksBar);
                    else if (p.iTipoZona === 5 && p.iKind === 3) p.ingresoCorregido = parseFloat(p.importe);// + importeGastosGeneral;
                    else p.ingresoCorregido = parseFloat(p.importe);
                    total += parseFloat(p.ingresoCorregido);
                });
                conceptoIngresos.total = total;
            }

            if (conceptoPagos !== undefined) {
                let total = 0.0;
                conceptoPagos.productos.forEach(p => {
                    if (p.iTipoZona === 0 && p.iKind === 6) p.cobroCorregido = parseFloat(p.importe) - parseFloat(ventaPacksBar);
                    else if (p.iTipoZona === 1 && p.iKind === 6) p.cobroCorregido = parseFloat(p.importe) + parseFloat(ventaPacksBar);
                    else p.cobroCorregido = parseFloat(p.importe);
                    total += parseFloat(p.cobroCorregido);
                });
                conceptoPagos.total = total;
            }

            if (conceptoIngresos !== undefined && conceptoPagos !== undefined) {
                caja.descuadre = conceptoPagos.total - conceptoIngresos.total;
                if (Math.abs(caja.descuadre) < 0.0001) caja.descuadre = 0.0;
                //if (caja.iTipoZona === 0 || caja.iTipoZona === 1) descuadreBarBolera += caja.descuadre;

                switch (caja.iTipoZona) {
                    case 0: // Bolera
                        descuadreBolera += caja.descuadre;
                        cajaBolera = caja.cajaId;
                        break;
                    case 1: // Bar
                        descuadreBar += caja.descuadre;
                        cajaBar = caja.cajaId;
                        break;
                    case 5: // Arcade
                        descuadreArcade += caja.descuadre;
                        cajaArcade = caja.cajaId;
                        break;
                    default: break;
                }

            };

        });

        this.setState({
            ...this.state,
            datosCierre: datosCierre,
            descuadreBarBolera: descuadreBarBolera,
            descuadreBolera: descuadreBolera, cajaBolera: cajaBolera,
            descuadreBar: descuadreBar, cajaBar: cajaBar,
            descuadreArcade: descuadreArcade, cajaArcade: cajaArcade
        });

    }

    calculateTotal = (rows) => {
        let total = 0;
        rows.forEach((r) => {
            total += parseInt(r.numPartidas);
        })
        return total;
    };


    getPartidasPorTipo = () => {

        let URL = 'VPartidaPorTipo?centro_id=' + this.props.centroDiaSelected.centro.id + '&date=' + this.props.centroDiaSelected.dia;

        getData(URL,
            (response) => {
                this.setState({ ...this.state, partidas: this.calculateTotal(response.data) });
            },
            (error) => {
                this.props.openDialog('SimpleMessage', {
                    message: 'error obteniendo las partidas por tipo'
                }, 'error-cierre-diario-resumen-get-partidas', false, 'sm');
            },
            this.props.user
        );

    };


    compareDescr = (a, b) => {
        if (a.descr < b.descr) return 1;
        if (a.descr > b.descr) return -1;
        return 0;
    }

    compareProductos = (a, b) => {
        if (a.producto < b.producto) return 1;
        if (a.producto > b.producto) return -1;
        if (a.iTipoZona < b.iTipoZona) return -1;
        if (a.iTipoZona > b.iTipoZona) return 1;
        if (a.iKind < b.iKind) return -1;
        if (a.iKind > b.iKind) return 1;
        return 0;
    }

    generateCierreDiarioControls = () => {

        let ventaPacksBar = 0.0;
        const packsBar = this.props.datosCierreDiario.find(p => p.iTipoZona === 1 && p.iKind === -8);
        if (packsBar !== undefined) {
            ventaPacksBar = packsBar.importe;
        };

        const { classes } = this.props;

        let datos = [];
        this.state.datosCierre.forEach(d => datos.push(d));

        return datos.map((caja, i) => {

            if (caja.conceptos[0] === undefined || caja.conceptos[1] === undefined) {
                return (<div></div>);
            }

            return (
                <Paper key={'caja_' + caja.cajaId} className={classes.paperCaja} elevation={1}>

                    <Paper elevation={0}>

                        <div className={classes.cajaSection}>
                            <div className={classes.cajaSectionLeft}>
                                <Typography className={classes.cajaSectionFontDescr} variant="subtitle1">{caja.descr}</Typography>

                                <div className={classes.cajaSectionItem}>
                                    <Typography className={classes.cajaSectionFont} variant="subtitle1">{caja.partidas ? 'Partidas:' : ''}</Typography>
                                    <Typography className={classes.cajaSectionFont} variant="subtitle1">{caja.partidas ? <IntNumberFormatText value={this.state.partidas} /> : ''}</Typography>
                                </div>
                            </div>

                            <div className={classes.cajaSectionRight}>
                                {caja.iTipoZona !== 9 ?
                                    <div className={classes.cajaSectionItem}>
                                        <Typography className={classes.cajaSectionFont} variant="subtitle1">Descuadre:</Typography>
                                        <Tooltip title="Diferencia entre ingresos y cobros de la caja" TransitionComponent={Fade} TransitionProps={{ timeout: 600 }} classes={{ tooltip: this.props.classes.tooltip }}>
                                            <Typography className={classes.cajaSectionFont} variant="subtitle1" color={caja.descuadre < 0 ? 'error' : ''}><FloatNumberFormatText value={caja.descuadre} /></Typography>
                                        </Tooltip>
                                    </div>
                                    : <div> </div>}
                            </div>
                        </div>
                    </Paper>


                    {this.generateConceptos(caja, ventaPacksBar, i)}
                </Paper>
            );

        });

    };

    generateConceptos = (caja, ventaPacksBar, i) => {

        if (caja.conceptos[0] !== undefined && caja.conceptos[1] !== undefined) {

            const conceptoIngresos = caja.conceptos[0];
            const conceptoPagos = caja.conceptos[1];

            return (
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <div style={{ width: '49%' }}>
                        {this.generateConceptosIngresos(conceptoIngresos, caja, ventaPacksBar, i)}
                    </div>

                    <div style={{ width: '49%' }}>
                        {this.generateConceptosPagos(conceptoPagos, caja, ventaPacksBar, i)}
                    </div>
                </div>
            );
        }
    };

    generateConceptosIngresos = (conceptoIngresos, caja, ventaPacksBar, i) => {

        if (conceptoIngresos === undefined) {
            return (<div></div>);
        };

        const { classes } = this.props;

        return (

            <Paper key={'concepto_' + caja.cajaid + '_0'} className={classes.paperConcepto} elevation={0}>

                <div className={i === 1 ? classes.conceptTitleContainerSecondary : i === 2 ? classes.conceptTitleContainerblack : classes.conceptTitleContainer}>
                    <Typography className={classes.conceptTitle} variant="subtitle1"> {conceptoIngresos.concepto} </Typography>

                    <div className={classes.conceptSectionItem}>
                        <Typography className={classes.conceptTitle} variant="subtitle1">Total:</Typography>

                        <Typography className={classes.conceptTitle} variant="subtitle1"> <FloatNumberFormatText value={conceptoIngresos.total} /></Typography>
                    </div>

                </div>
                {this.generateProductosIngresos(conceptoIngresos.productos, caja, ventaPacksBar)}
            </Paper>

        );
    };

    generateConceptosPagos = (conceptoPagos, caja, ventaPacksBar, i) => {
        if (conceptoPagos === undefined) {
            return (<div></div>);
        };

        const { classes } = this.props;
        return (

            <Paper key={'concepto_' + caja.cajaid + '_1'} className={classes.paperConcepto} elevation={0}>

                <div className={i === 1 ? classes.conceptTitleContainerSecondary : i === 2 ? classes.conceptTitleContainerblack : classes.conceptTitleContainer}>
                    <Typography className={classes.conceptTitle} variant="subtitle1">{conceptoPagos.concepto}</Typography>

                    <div className={classes.conceptSectionItem}>
                        <Typography className={classes.conceptTitle} variant="subtitle1">Total:</Typography>

                        <Typography className={classes.conceptTitle} variant="subtitle1"> <FloatNumberFormatText value={conceptoPagos.total} /></Typography>
                    </div>
                </div>

                {this.generateProductosPagos(conceptoPagos.productos, caja, ventaPacksBar)}
            </Paper>

        );
    };

    generateProductosIngresos = (productos, caja, ventaPacksBar) => {

        const { classes } = this.props;

        const tooltipText = caja.iTipoZona === 5 ? "Ingreso corregido con gastos de caja general" : "Ingreso corregido con ventas packs de bar";

        return (
            <div key={'grid_ingresos_' + caja.cajaid}>

                <div className={classes.topGrid}>
                    <div className={classes.gridCellsHeaderleft}>Concepto Ingreso</div>
                    <div className={classes.gridCellsHeaderCenter}>Ingreso Inicial</div>
                    <Tooltip title={tooltipText} TransitionComponent={Fade} TransitionProps={{ timeout: 600 }} classes={{ tooltip: this.props.classes.tooltip }}>
                        <div className={classes.gridCellsHeaderRight}>Ingreso Corregido</div>
                    </Tooltip>
                </div>

                {productos.map((p, i) => {
                    const { producto, importe, ingresoCorregido } = p;

                    return (
                        <div className={classes.gridRow} key={i}>
                            <div className={classes.gridCells}>{producto ? producto : ''}</div>
                            <div className={`${classes.gridCells} ${classes.rtl}`}><FloatNumberFormatText value={importe ? importe : 0.00} /></div>
                            <div className={`${classes.gridCells} ${classes.rtl}`}><FloatNumberFormatText value={ingresoCorregido ? ingresoCorregido : 0.00} /></div>
                        </div>
                    );

                })}

            </div>
        );
    };

    generateProductosPagos = (productos, cajaid, ventaPacksBar) => {

        const { classes } = this.props;

        return (
            <div key={'grid_cobros_' + cajaid}>

                <div className={classes.topGrid}>
                    <div className={classes.gridCellsHeaderleft}>Concepto Cobro</div>
                    <div className={classes.gridCellsHeaderCenter}>Cobro Input</div>
                    <Tooltip title="Cobro corregido con ventas packs de bar" TransitionComponent={Fade} TransitionProps={{ timeout: 600 }} classes={{ tooltip: this.props.classes.tooltip }}>
                        <div className={classes.gridCellsHeaderRight}>Cobro Corregido</div>
                    </Tooltip>
                </div>

                {productos.map((p, i) => {
                    const { producto, importe, cobroCorregido } = p;
                    return (
                        <div className={classes.gridRow} key={i}>
                            <div className={classes.gridCells}>{producto ? producto : ''}</div>
                            <div className={`${classes.gridCells} ${classes.rtl}`}><FloatNumberFormatText value={importe ? importe : 0.00} /></div>
                            <div className={`${classes.gridCells} ${classes.rtl}`}><FloatNumberFormatText value={cobroCorregido ? cobroCorregido : 0.00} /></div>
                        </div>
                    );

                })}

            </div>
        );
    };


    renderResumen = () => {
        const { classes } = this.props;
        return (
            <Paper className={classes.paperResumenTable}>
                {this.props.resumenCierreDiario.map((itemResume, i) => {

                    let styleClass = classes.typoOK;
                    if (itemResume.iError === 1) {
                        styleClass = classes.typoError;
                    }
                    else if (itemResume.iError === 2) {
                        styleClass = classes.typoDefault;
                    }

                    return (
                        <Typography variant="subtitle2" key={i} className={styleClass}>{itemResume.mensaje}</Typography>
                    )

                })}
            </Paper>
        )
    }


    modifyValue = (v, producto) => {
        this.props.modifyDatosCierreDiario({ ...producto, importe: v });
    };

    cerrarDia = () => {

        this.setState({ ...this.state, showSpinner: true });

        this.props.cerrarDiaCierreDiario(this.props.centroDiaSelected.centro.id, this.props.centroDiaSelected.dia, () => {

            // this.setState({ ...this.state, showSpinner: true });

            const win = window.open(process.env.PUBLIC_URL + '/loading_report.html', '_blank');

            let url = '';

            createReport(
                {
                    reportDefinition: { id: 1 },
                    values: {
                        centroId: this.props.centroDiaSelected.centro.id,
                        iniDate: this.props.centroDiaSelected.dia,
                        page: -1
                    }
                },
                "PDF",
                this.props.user, '')
                .then(response => {
                    url = window.URL.createObjectURL(new Blob([response.data], { type: "application/pdf" }));
                    win.location.href = url;
                }).catch(error => {
                    this.props.openDialog('SimpleMessage', {
                        message: error.response.status == 401 ? error.response.data : 'ERROR generating PDF'
                    }, 'error-opem-report-pdf', false, false);
                }).then(() => {
                    this.setState({ ...this.state, showSpinner: false });
                });

        });
    }

    // okDescuadre = (observaciones) => {

    //     let obs_url = 'DEArqueos/ObservacionesCajaGeneral?centro_id=' + this.props.centroDiaSelected.centro.id + '&date=' + this.props.centroDiaSelected.dia;

    //     postData(obs_url,
    //         () => {
    //             this.cerrarDia();
    //         },
    //         () => {
    //             this.props.openDialog('SimpleMessage', {
    //                 message: 'ERROR actualizando observaciones'
    //             }, 'error-updating-observaciones', false, 'sm');
    //         },
    //         { "obs": observaciones },
    //         this.props.user
    //     );

    // }

    // entrarDescuadre = () => {

    //     let obs = '';

    //     let obs_url = 'DEArqueos/ArqueoIngresosBanco?centro_id=' + this.props.centroDiaSelected.centro.id + '&date=' + this.props.centroDiaSelected.dia;

    //     getData(obs_url,
    //         (response) => {
    //             obs = response.data.observDescuadre;
    //             this.props.openDialog('TextBoxDialog', {
    //                 okHandler: this.okDescuadre,
    //                 title: 'Descuadre',
    //                 label: 'Observaciones de descuadre',
    //                 obs: obs,
    //             }, 'cierre-diario-observaciones-descuadre', false, 'xs');
    //         },
    //         (error) => {
    //             this.props.openDialog('SimpleMessage', {
    //                 message: 'error obteniendo observaciones'
    //             }, 'error-cierre-diario-resumen-arqueo-banco', false, 'sm');
    //         },
    //         this.props.user
    //     );


    // }


    obtenerObservacionesPorDescuadre = () => {

        let obs = '';

        let obs_url = 'DEArqueos/ObservacionesArqueos?centro_id=' + this.props.centroDiaSelected.centro.id + '&date=' + this.props.centroDiaSelected.dia;

        getData(obs_url,
            (response) => {
                obs = response.data.arqueos;
                this.props.openDialog('CierreDiarioObservaciones', {
                    okHandler: this.guardarObservacionesPorDescuadre,
                    obs: obs,
                    descuadreBar: this.state.descuadreBar,
                    descuadreBolera: this.state.descuadreBolera,
                    descuadreArcade: this.state.descuadreArcade,
                    cajaBolera: this.state.cajaBolera,
                    cajaBar: this.state.cajaBar,
                    cajaArcade: this.state.cajaArcade,
                }, 'cierre-diario-observaciones-descuadre', false, 'xs');
            },
            (error) => {
                this.props.openDialog('SimpleMessage', {
                    message: 'error obteniendo observaciones'
                }, 'error-cierre-diario-resumen-arqueo-banco', false, 'sm');
            },
            this.props.user
        );

    }


    guardarObservacionesPorDescuadre = (observaciones) => {

        let obs_url = 'DEArqueos/ObservacionesArqueos?centro_id=' + this.props.centroDiaSelected.centro.id + '&date=' + this.props.centroDiaSelected.dia;

        postData(obs_url,
            () => {
                this.cerrarDia();
            },
            () => {
                this.props.openDialog('SimpleMessage', {
                    message: 'ERROR actualizando observaciones'
                }, 'error-updating-observaciones', false, 'sm');
            },
            observaciones,
            this.props.user
        );

    }


    hanldeOKClick = () => {
        if (!this.props.isDiaCerrado) {
            //this.props.cerrarDiaCierreDiario(this.props.centroDiaSelected.centro.id, this.props.centroDiaSelected.dia, () => {
            if (Math.abs(this.state.descuadreBar) >= 5 || Math.abs(this.state.descuadreBolera) >= 5 || Math.abs(this.state.descuadreArcade) >= 5) {
                this.obtenerObservacionesPorDescuadre();
            }
            else {
                this.cerrarDia();
            }
            //});
        }
        else {
            this.props.unlockCierreDiario(this.props.centroDiaSelected.centro.id, this.props.centroDiaSelected.dia);
            this.props.nextStep();
        }

    };

    render() {

        const { classes } = this.props;


        if (!this.state.showSpinner) {
            return (
                <div className={classes.root}>
                    {this.renderResumen()}
                    {this.generateCierreDiarioControls()}
                    <div>
                        <Button className={classes.buttonsBottom} variant="contained" color="secondary" onClick={this.props.prevStep}>Atrás</Button>
                        <Button
                        hidden={![0, 4, 5, 14, 15, 12, 17, 20].includes(this.props.userProfile.selectedCentroProfile.iPerfil) ||
                            (![0, 4, 5, 15, 17, 18].includes(this.props.userProfile.selectedCentroProfile.iPerfil) && this.props.isDiaCerrado)} 
                            className={classes.buttonsBottom} 
                            variant="contained" color="primary" onClick={this.hanldeOKClick} >
                            {this.props.isDiaCerrado ? 'Modificar cierre' : 'Cierre definitivo'}
                        </Button>
                    </div>
                </div>
            );

        };

        return (
            <div className={classes.spinnerContainer}>
                <CircularProgress className={classes.spinner} color="primary" />
            </div>
        );
    };

};

CierreDiarioResumen.propTypes = {
    //state
    user: PropTypes.object.isRequired,
    centroDiaSelected: PropTypes.object.isRequired,
    isDiaCerrado: PropTypes.bool.isRequired,
    datosCierreDiario: PropTypes.array.isRequired,
    isLoading: PropTypes.bool.isRequired,


    //dispatch
    getResumenCierreDiario: PropTypes.func.isRequired,
    getDatosCierreDiario: PropTypes.func.isRequired,
    modifyDatosCierreDiario: PropTypes.func.isRequired,
    cerrarDiaCierreDiario: PropTypes.func.isRequired,
    unlockCierreDiario: PropTypes.func.isRequired,
    prevStep: PropTypes.func.isRequired,

    //parameters


};

function mapStateToProps(state) {
    return {
        user: state.oidc.user,
        centroDiaSelected: state.centroDiaSelected,
        datosCierreDiario: state.datosCierreDiario.datos,
        resumenCierreDiario: state.resumenCierreDiario.resumen,
        isLoading: state.resumenCierreDiario.isLoading,
        isDiaCerrado: state.centroDiaSelected.isDiaCerrado,
        userProfile: state.userProfile,
    };
};

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getResumenCierreDiario,
        cerrarDiaCierreDiario,
        unlockCierreDiario,
        openDialog,
        hideDialog
    }, dispatch);
};


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(CierreDiarioResumen));
